import { render, staticRenderFns } from "./KpiVentaCard.vue?vue&type=template&id=13153277"
import script from "./KpiVentaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiVentaCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports